import React, { useEffect } from "react";
import { useImageStore } from "../../stores/useImageStores";
import "./BridalGrid.css";

const BridalGrid = () => {
  const { imagesByCategory, getImagesByCategory } = useImageStore();
  const images = imagesByCategory.bridal || [];

  useEffect(() => {
    getImagesByCategory("bridal");
  }, [getImagesByCategory]);

  return (
    <div className="bridal-page">

      <div className="bridal-grid">
        {images.map((img, i) => (
          <img
            key={i}
            src={img.image_url}
            alt="Bridal"
            loading="lazy"
            decoding="async"
          />
        ))}
      </div>
    </div>
  );
};

export default BridalGrid;
